// src/syslic/dashboard/revenue/monthlyRevenueService.js

import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import syslic from '@/syslic'

const fetchReportData = async (vm = null, filters = {}) => {
  try {
    const profile = syslic.authentication.getProfile()
    if (!profile || !profile.id) throw new Error('ID do usuário não encontrado')

    const userID = profile.id

    // Monta query params para filtros
    const params = new URLSearchParams({ userID })

    if (filters.estado) params.append('estado', filters.estado)
    if (filters.periodo) params.append('periodo', filters.periodo)

    // const url = `http://localhost:5000/Reports/GetAllReports?${params.toString()}`
    const url = `https://syslic.com.br/reports/GetAllReports?${params.toString()}`

    const response = await axios.get(url)

    return response.data
  } catch (error) {
    // (mesma lógica de erro que você já tem)
    let errorMessage = 'Erro desconhecido ao buscar dados de eficiência'

    if (error.response) {
      errorMessage = error.response.data?.message
        || error.response.statusText
        || `Erro ${error.response.status}`
    } else if (error.request) {
      errorMessage = 'O servidor não respondeu. Verifique sua conexão.'
    } else {
      errorMessage = error.message
    }

    if (vm?.$toast) {
      vm.$toast({
        component: ToastificationContent,
        props: {
          title: 'Falha na requisição',
          text: errorMessage,
          icon: 'AlertTriangleIcon',
          variant: 'danger',
          timeout: 5000,
        },
      })
    }

    return []
  }
}

export default fetchReportData
